export default {
    POST_VALIDATION_GENERATION_COMP: "/generacion/comprobantes/validacion"
}